import { FACTORY_ADDRESS as V3_FACTORY_ADDRESS } from '@uniswap/v3-sdk';
export { V3_FACTORY_ADDRESS };
export const MULTICALL_ADDRESS = "0x1F98415757620B543A52E61c46B32eB19261F984";
export const V3_ROUTER_ADDRESS = "0xE592427A0AEce92De3Edee1F18E0157C05861564";
export const SWAP_ROUTER_ADDRESS = "0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45";
export const QUOTER_ADDRESS = "0xb27308f9F90D607463bb33eA1BeBb41C27CE5AB6";
export const NONFUNGIBLE_POSITION_MANAGER_ADDRESS = "0xC36442b4a4522E871399CD717aBDD847Ab11FE88";
export const TICK_LENS_ADDRESS = "0xbfd8137f7d1516d3ea5ca83523914859ec47f573";
